<template>
  <BaseModal
    :open="modalState.open"
    :blocking="modalState.blocking"
    @close="close"
  >
    <component :is="modalState.component" v-bind="modalState.props" />
  </BaseModal>
</template>

<script setup>
import { reactive } from 'vue'
import BaseModal from './BaseModal.vue'

const modalState = reactive({
  open: false,
  component: null,
  props: {},
  blocking: false,
})

function open(component, props = {}, options = {}) {
  modalState.component = component
  modalState.props = props
  modalState.blocking = options.blocking || false
  modalState.open = true
}

function close() {
  modalState.open = false
}

defineExpose({ open, close })
</script>

